import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Ensinos Específicos',
    path: '/administracao/ensinoescola',
    name: 'ensinoescola',
    component: () => import('@/views/administracao/ensinoescola/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ENSINOSESPECIFICOSNOVO_MENU_2200101001],
    },
    goesToMenu: true,
  },
];
